import { render } from "./OrderDetailCost.vue?vue&type=template&id=1bb650dc&scoped=true&ts=true"
import script from "./OrderDetailCost.vue?vue&type=script&lang=ts"
export * from "./OrderDetailCost.vue?vue&type=script&lang=ts"

import "./OrderDetailCost.vue?vue&type=style&index=0&id=1bb650dc&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb650dc"]])

export default __exports__